module.exports = __webpack_public_path__ + "img/Fondo_Menu_inferior_optimo_alto.c48afcb7.svg";